import { FlashList, FlashListRef } from '@shopify/flash-list'
import React from 'react'
import { useTheme } from 'styled-components/native'

import { SearchListHeader } from 'features/search/components/SearchListHeader/SearchListHeader'
import {
  convertAlgoliaVenue2AlgoliaVenueOfferListItem,
  getReconciledVenues,
} from 'features/search/helpers/searchList/getReconciledVenues'
import { removeGeolocFromVenue } from 'features/search/helpers/searchList/removeGeolocFromVenue'
import { SearchListProps } from 'features/search/types'
import { useFeatureFlag } from 'libs/firebase/firestore/featureFlags/useFeatureFlag'
import { RemoteStoreFeatureFlags } from 'libs/firebase/firestore/types'
import { Offer } from 'shared/offer/types'
import { LineSeparator } from 'ui/components/LineSeparator'

const keyExtractor = (item: Offer) => item.objectID

export const SearchList = React.forwardRef<FlashListRef<Offer>, SearchListProps>(
  (
    {
      nbHits,
      hits,
      renderItem,
      autoScrollEnabled,
      refreshing,
      onRefresh,
      onEndReached,
      onScroll,
      userData,
      venuesUserData,
      artistSection,
      numColumns,
      isGridLayout,
      shouldDisplayGridList,
      onViewableItemsChanged,
      onViewableVenuePlaylistItemsChanged,
    },
    ref
  ) => {
    const { tabBar, designSystem } = useTheme()
    const isEnabledVenuesFromOfferIndex = useFeatureFlag(
      RemoteStoreFeatureFlags.ENABLE_VENUES_FROM_OFFER_INDEX
    )

    const venues = hits.venueNotOpenToPublic[0]
      ? [removeGeolocFromVenue(hits.venueNotOpenToPublic[0]), ...hits.venues]
      : hits.venues

    return (
      <FlashList
        ref={ref}
        key={isGridLayout ? 'grid_search_results' : 'list_search_results'}
        testID="searchResultsFlashlist"
        data={hits.offers}
        keyExtractor={keyExtractor}
        ListHeaderComponent={
          <SearchListHeader
            nbHits={nbHits}
            hasOfferHits={hits.offers.length > 0}
            userData={userData}
            venues={
              isEnabledVenuesFromOfferIndex
                ? getReconciledVenues(hits.offers, venues)
                : venues.map(convertAlgoliaVenue2AlgoliaVenueOfferListItem)
            }
            artistSection={artistSection}
            venuesUserData={venuesUserData}
            shouldDisplayGridList={shouldDisplayGridList}
            onViewableVenuePlaylistItemsChanged={onViewableVenuePlaylistItemsChanged}
          />
        }
        ItemSeparatorComponent={isGridLayout ? undefined : LineSeparator}
        renderItem={renderItem}
        numColumns={isGridLayout ? numColumns : undefined}
        refreshing={refreshing}
        onRefresh={onRefresh}
        onEndReached={autoScrollEnabled ? onEndReached : undefined}
        scrollEnabled={nbHits > 0}
        onScroll={onScroll}
        contentContainerStyle={{
          paddingBottom: tabBar.height + designSystem.size.spacing.xxxl,
        }}
        keyboardShouldPersistTaps="handled"
        keyboardDismissMode="on-drag"
        onViewableItemsChanged={onViewableItemsChanged}
      />
    )
  }
)
SearchList.displayName = 'SearchList'
